export const getDefaultPaymentMethod = (paymentMethods, patientId) =>
  paymentMethods.find(pm => pm.isDefault && pm.holderId === patientId) ||
  paymentMethods.find(pm => pm.isDefault) ||
  paymentMethods[0];
